// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"DefaultThemeWrapper_scrollbar__npJLb","wrapper":"DefaultThemeWrapper_wrapper__10n1H","cursor":"DefaultThemeWrapper_cursor__143Uu"};